import facetsConfig from "./facetsConfig";

export const CoveStyles = (isMobile, gridColumns, thinkPage = false) => {
  const generateFacetCSS = (facet) => {
    return `
      atomic-facet-manager div[class^="Grid_column"] div:has(> atomic-facet[facet-id="${facet.facetId}"].atomic-hidden)::after {
        content: "${facet.content}";
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 48px;
        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;
        padding-left: 20px;
        padding-right: 20px;
        position: relative;
        background-color: #D7D2CB;
        line-height: 24px;
        font-size: 0.9375rem;
        padding: 12px;
        font-family: var(--lbs-base-font-family),sans-serif;
        font-weight: var(--atomic-font-normal);
        color: #6e6259;
      }
    `;
  };

  // Generate the CSS for all facets
  const facetsCSS = facetsConfig?.map(generateFacetCSS).join("");

  // Include generated CSS with our base CSS
  return `
    ${facetsCSS}
  
    atomic-facet-manager div[class^="Grid_column"] {
      position: relative;
    }
  
atomic-search-interface atomic-search-layout.hydrated{
  max-width: 1150px !important;
}
  
/* THIS IS INTENTIONAL COVEO COMPONENTS SHOULD BE ADDED TO THE DOM */
div[class^="thinkLanding"]{
  display:none;
}
  
atomic-search-interface atomic-search-layout atomic-layout-section[section="search"] {
  width: 100% !important;
  max-width: none;
}
  
atomic-search-layout atomic-layout-section[section='facets'] * {
  position: relative;
}
  
atomic-facet::part(facet) {
  background: none;
  padding: 0;
  margin-top: 20px;
  border-style: solid;
  border: 1px;
}
  
atomic-facet::part(placeholder) {
  padding: 7px;
  margin-bottom: 0;
  margin-top: 20px;
}
  
atomic-facet::part(label-button)[aria-expanded='true']{
  border: 1px solid #001e62;
}
  
atomic-facet::part(clear-button-icon) {
  width: 12px;
  height: 12px;
  margin-right: 10px;
}
  
// CLS prevention — space reservation for Atomic web components
  
atomic-search-interface:not([is-initialized]) {
  visibility: hidden;
}
  
atomic-query-summary {
  display: block;
  min-height: 24px;
}
  
atomic-pager {
  display: block;
  min-height: 48px;
}
  
atomic-results-per-page {
  display: block;
  min-height: 40px;
}
  
atomic-layout-section[section="status"] {
  display: block;
  min-height: 44px;
}
  
// End of CLS prevention — space reservation for Atomic web components
  
atomic-facet::part(clear-button) {
  font-size: 1rem;
  background: initial;
  color: #001e62;
  display:none;
}
  
atomic-facet::part(label-button) {
  line-height: 24px;
  color: #001e62;
  font-size: 0.9375rem;
  padding: 12px;
  font-family: var(--lbs-base-font-family),sans-serif;
  font-weight:var(--atomic-font-normal);
  background-color: var(--atomic-background);
}
  
atomic-facet::part(value-label) {
  font-family: var(--lbs-base-font-family),sans-serif;
  color: #001e62;
  font-size: 1rem;
  line-height: 24px;
}
  
atomic-facet::part(show-more) {
  font-family: var(--lbs-base-font-family);  
}
  
atomic-facet::part(value-count) {
  font-family: var(--lbs-base-font-family);  
}
  
atomic-facet::part(search-input) {
  padding: 25px;
  font-size: 1rem;
  color: #001e62;
  font-family:  var(--lbs-base-font-family),sans-serif;
  border-radius: 0px;
}
atomic-facet::part(search-icon) {
  display:none;
 }
atomic-facet::part(search-wrapper) {
  height: 60px;
  padding:0;
}
atomic-facet::part(value-checkbox-label):hover{
 background:none;
}
  
atomic-facet::part(value-checkbox){
  border-radius: 0px;
}
  
atomic-facet::part(values) {
  position: absolute;
  background: white;
  z-index: 1;
  margin-top: 2.5px;
  width: 100%;
  overflow: hidden;
  box-shadow: 0px 4px 15px -3px rgba(0,0,0,0.5);
  max-height: 300px;
  overflow-y: auto;
  padding: 15px;
} 
  
atomic-facet::part(values) li {
  flex-wrap: wrap;
}
atomic-facet::part(values) .items-center {
  flex-wrap: wrap;
}
  
  
atomic-search-box {
  height:48px;
  padding-left: 0;
  margin-bottom:16px;
}
  
atomic-facet::part(value-label) {
  white-space: normal;
  padding-left: 15px;
  }
  
atomic-search-box::part(query-suggestion-content) {
  color: #001e62;
  font-family: var(--lbs-base-font-family),sans-serif;
  font-size: 1rem;
}
atomic-search-box::part(submit-icon) { 
  fill:  #001e62;
  width: 20px;
  height: 20px;
}
atomic-search-box::part(wrapper) { 
  align-items: center;
}
atomic-search-box::part(clear-icon) {
  fill:  #001e62;
} 
atomic-search-box::part(submit-button) { 
  background:#fff;
  width:40px;
  height: 38px;
  margin-right: 5px;
}
  
atomic-search-box::part(submit-button):focus-visible {
  outline-color: var(--atomic-primary-light);
  outline-offset: -4px;
}
  
atomic-sort-dropdown {
  font-family: var(--lbs-base-font-family),sans-serif;
  font-weight: 500;
  display: flex;
  justify-content: flex-end;
  line-height: 1.5;
  font-size: 0.75rem;
}
  
atomic-sort-dropdown::part(select)::focus-visible,
atomic-sort-dropdown:focus-within {
  outline: 2px solid var(--atomic-primary-light);
}
  
@media screen and (min-width: 480px) {
  atomic-sort-dropdown {
  font-size: 1rem;
  }
}
  
atomic-sort-dropdown::part(placeholder) {
  height: 1.75rem;
}
  
atomic-sort-dropdown::part(label) {
  font-weight: normal;
  font-size: 0.75rem;
}
  
@media screen and (min-width: 480px) {
  atomic-sort-dropdown::part(label) {
  font-size: 1rem;
  }
}
  
atomic-sort-dropdown::part(select-separator) {
  border-color: transparent;
  color: #001e62;
}
  
atomic-search-box::part(input) {
  font-size: 1rem;
  padding: 20px 70px 20px 10px;
  text-indent: unset;
  color:#001e62;
  font-family: var(--lbs-base-font-family),sans-serif;
}
  
atomic-search-box::part(input)::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: capitalize;
}
atomic-search-box::part(input):-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: capitalize;
}
atomic-search-box::part(input)::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: capitalize;
}
atomic-search-box::part(input):-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: capitalize;
}
atomic-search-box::part(input)::placeholder { /* Recent browsers */
  text-transform: capitalize;
}
  
atomic-query-summary::part(container) {
  color: #001e62;
  line-height: 1.5;
  font-size: 0.75rem;
  margin-right: 8px;
  font-family: var(--lbs-base-font-family),sans-serif;
}
  
@media screen and (min-width: 480px) {
  atomic-query-summary::part(container) {
    font-size: 1rem;
  }
}
  
atomic-results-per-page {
  display: none;
}
  
atomic-results-per-page::part(label) {
  margin: 19px;
  margin-left: 0;
  text-transform: capitalize;
  color: #001e62;
  font-size: 0.75rem;
  margin-right: 8px;
}
  
atomic-sort-dropdown::part(select) {
  border-radius: 0;
  font-size: 0.75rem;
  font-family: var(--lbs-base-font-family),sans-serif;
  font-weight: 500;
  color: #001e62;
  background-color: transparent;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid #001e62;
  padding: 0 30px 5px 0;
  margin: 4px 0 0 2px;
}
  
atomic-sort-dropdown::part(select)::focus-visible {
  outline: 2px solid var(--atomic-primary-light);;
}

atomic-sort-dropdown:focus-within {
  outline: 2px solid var(--atomic-primary-light);;
}
  
@media screen and (min-width: 480px) {
  atomic-sort-dropdown::part(select) {
    font-size: 0.9375rem;
    margin: 4px 0 0 11px;
  }
}
  
atomic-results-per-page::part(button active-button) {
  border: 0;
  background: #eae8e5;
  font-size: 0.875rem;
  font-weight: 700;
  font-family: var(--lbs-base-font-family),sans-serif;
}
  
atomic-search-layout atomic-layout-section[section='status'] {
  margin-top: 20px;
  display: block;
}
  
atomic-breadbox::part(label){   
  font-family: var(--lbs-base-font-family),sans-serif;
  font-size: 1rem;
  line-height: 24px;
  margin: 0 13px 0 0;
  font-weight: 400;
}
  
atomic-breadbox::part(breadcrumb-list) {
  padding-top: 5px;
}
  
atomic-breadbox::part(breadcrumb-button),
atomic-breadbox::part(show-more),
atomic-breadbox::part(clear),
atomic-breadbox::part(show-less) {   
  font-family: var(--lbs-base-font-family),sans-serif;
  line-height: 1.5;
  font-size: 1rem;
  color: #001e62;
  padding: 3px 6px;
  border: 1px solid #d7d2cb;
  font-size: 0.75rem;
  position: relative;
  text-decoration: none;
  font-weight: 700;
  background-color: transparent;
  transition: background-color 0.3s, color 0.3s;
}
  
atomic-breadbox::part(clear) {
  margin-left: 8px;
}
  
atomic-breadbox::part(breadcrumb-button):hover,
atomic-breadbox::part(show-more):hover,
atomic-breadbox::part(clear):hover,
atomic-breadbox::part(show-less):hover {
  background-color: #001e62;
  color: #fff;
}

atomic-breadbox::part(breadcrumb-button):focus-visible,
atomic-breadbox::part(show-more):focus-visible,
atomic-breadbox::part(clear):focus-visible,
atomic-breadbox::part(show-less):focus-visible {
  outline: 2px solid #399ffe;
  outline-offset: 2px;
  box-shadow: 0 0 0 3px rgba(57, 159, 254, 0.2);
}
  
atomic-breadbox::part(breadcrumb-label) {
  color: inherit;
}
  
atomic-breadbox::part(clear){   
  font-family: var(--lbs-base-font-family),sans-serif;
}
  
atomic-result-list::part(result-list-grid-clickable-container) {
  padding: 0;
}
  
.list-wrapper {
  word-break: break-word;
}
  
atomic-result-list::part(result-list),
.result-list {
  grid-template-columns: ${
    isMobile ? "repeat(1, 1fr)" : `repeat(${gridColumns}, 1fr)`
  } ;
}

atomic-search-layout atomic-layout-section[section='pagination']>* {
  margin-top: var(--atomic-layout-spacing-y);
}
atomic-search-layout atomic-layout-section[section='main'] {
  margin-bottom: var(--atomic-layout-spacing-y);
}

${
  thinkPage &&
  `
atomic-search-interface atomic-search-layout atomic-layout-section[section="search"]>* {
  padding-top: 0;
  margin-bottom: 40px;
}
`
}

.result-list-grid-clickable {
  content: "";
  position: inherit;
  inset: 0;
}

.result-list-grid-clickable-container {
  padding: 0;
}

.outline .result-list-grid-clickable-container {
  position: relative;
}

@media (min-width: 1024px) {
  .outline.result-list-grid-clickable-container {
    border: 1px solid transparent;
    border-radius: 10px;
    transition: all 0.12s ease-out 0s;
  }
}

@media (min-width: 1024px) {
  .list-root.display-grid.image-small {
    grid-template-columns: repeat(${gridColumns}, 1fr);
  }
}

@media (min-width: 1024px) {
  .list-root.display-grid.density-normal, 
  .list-root.display-grid.density-compact {
    gap: 30px 15px;
  }
}

.list-root.display-grid {
  display: grid;
  justify-content: space-evenly;
}

.list-root.display-grid .result-component {
  height: 100%;
  box-sizing: border-box;
}

@media not all and (min-width: 1024px) {
  .list-root.display-grid.image-small, 
  .list-root.display-grid.image-icon, 
  .list-root.display-grid.image-none {
      gap: 5px;
  }
}
@media (min-width: 128px) and (max-width: 767px) {
  .course-search-results .application-box {
      box-shadow:none;
  }
}

.imageLink .Image {
  height: auto;
}
.coveo-loading-center {
  text-align: center;
  padding: 160px 0;
}
.coveo-loading-center .loader {
  margin-bottom: 10px;
}

atomic-tab-manager::part(tab-button) {
  font-size: 0.9375rem;
  padding: 12px;
  font-family: var(--lbs-base-font-family),sans-serif;
  font-weight: var(--atomic-font-normal);  
}

atomic-tab-manager::part(tab-button):hover {
  color: #001e62;
}

atomic-tab-manager::part(button-container)::after {
  height: 2.5px;
  bottom: -1.25px;
}

atomic-tab-manager::part(custom-list) {
  border-bottom: 1px solid #d7d2cb;
  display: flex !important;
}

atomic-tab-manager::part(custom-select) {
  display: none !important;
}

atomic-tab-manager::part(custom-select-container) {
  display: none !important;
}

atomic-layout-section {
  margin-top: 10px !important;
}

atomic-pager::part(page-button),
atomic-pager::part(previous-button),
atomic-pager::part(next-button) {
  min-width: 25px;
  min-height: 25px;
  padding: 2.5px;
}

atomic-pager::part(previous-button-icon),
atomic-pager::part(next-button-icon) {
  width: 12.5px;
}
`;
};
